// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"54847417","288":"54847417","563":"54847417","838":"54847417"}[chunkId] + ".chunk.css";
};